import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useLocale } from '../i18n/LocaleContext';
import { InfoIcon } from './Icons';

// Privacy, contact and the data-source note. They live in the header rather
// than a footer because the event list keeps loading as you scroll, so almost
// nobody reaches the bottom of the page.
export default function InfoMenu() {
  const { t } = useLocale();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) {
      return undefined;
    }
    const onPointerDown = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setOpen(false);
      }
    };
    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', onPointerDown);
    document.addEventListener('keydown', onKeyDown);
    return () => {
      document.removeEventListener('mousedown', onPointerDown);
      document.removeEventListener('keydown', onKeyDown);
    };
  }, [open]);

  const close = () => setOpen(false);

  return (
    <div className="info-menu" ref={ref}>
      <button
        type="button"
        className="header__link"
        onClick={() => setOpen((current) => !current)}
        aria-expanded={open}
        aria-haspopup="true"
        aria-label={t('legal.menu')}
        title={t('legal.menu')}
      >
        <InfoIcon size={17} />
        <span className="header__link-text">{t('legal.menu')}</span>
      </button>

      {open && (
        <div className="sort__menu info-menu__panel">
          <Link to="/privacy" className="sort__item" onClick={close}>
            {t('legal.privacy')}
          </Link>
          <Link to="/contact" className="sort__item" onClick={close}>
            {t('legal.contact')}
          </Link>
          <div className="info-menu__note">
            <p>{t('legal.coverage')}</p>
            <p>{t('legal.sources')}</p>
            <p>
              © {new Date().getFullYear()} {t('app.name')}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
